<script lang="ts" setup>
import GLink from '@consumer/components/GLink.vue'
</script>

<template>
  <GCard rounded shadow class="mt-6 !p-6 !lg:p-8">
    <h5 class="text-lg">Can&apos;t find what you&apos;re looking for?</h5>
    <p class="mt-4 mb-8">
      If you can&apos;t find your answer here and need to contact a support representative please submit a ticket.
    </p>
    <GButton
      :as="GLink"
      name="support-category-contact-us-button"
      secondary
      size="medium"
      class="!w-188px"
      label="Contact Us"
      href="/support/contact-us"
    />
  </GCard>
</template>
